import { useMutation } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { ampli } from '../../../../ampli';
import { postMyOwnTractors } from '../../../../api/user/mutations/postMyOwnTractors';
import { useGetUserProfile } from '../../../user/useGetUserProfile';
import { usePatchFlarelaneUserTags } from '../../flarelane/usePatchFlarelaneUserTags';

export const usePostMyOwnTractorsMutation = () => {
  const location = useLocation();
  const { userProfile } = useGetUserProfile();
  const { mutate: patchFlarelaneUserTags } = usePatchFlarelaneUserTags();

  return useMutation(postMyOwnTractors, {
    onSuccess: () => {
      if (userProfile) {
        patchFlarelaneUserTags({ lastRegisteredOwnTractor: new Date().toISOString() });
      }
    },
    onError: (error: Error) =>
      ampli.에러발생({
        '에러 내용': error.toString(),
        '에러 종류': '보유 트랙터 등록 실패',
        '에러가 발생한 URL': location.pathname,
      }),
  });
};
